define('viewmodels/VisualAnalytics/VisualanalyticsThresholds',['knockout', 'plugins/router', 'services/appsecurity', 'services/navigation', 'durandal/app', 'services/logger', 'durandal/system', 'viewmodels/GeneralSettings'],
    function (ko, router, appsecurity, navigation, app, logger, system, ObjGeneralSettings) {
        var title = 'RiskLevel';

        var AtViewModel = {
            title: title,
            attached: attached,
            detached: detached,
            appsecurity: appsecurity,
            pageinvoke: pageinvoke,
            AssessmentType: ko.observable(),
            RiskAreaList: ko.observableArray(),
            RiskAreaTabClick: RiskAreaTabClick,
            RiskFactorTabClick: RiskFactorTabClick,
            RiskFactorList: ko.observableArray(),
            ClickedRiskAreaId: ko.observable(),
            ClickedRiskAreaName: ko.observable(),
            ClickedRiskFactorId: ko.observable(),
            ClickedRiskFactorName: ko.observable(),
            CurrentYearofAssessment: ko.observable(),
            ThresholdValuesList: ko.observableArray(),
            ThresholdValuesListDup: ko.observableArray(),
            ThresholdChildList: ko.observableArray(),
            ThresholdCellBlur: ThresholdCellBlur,
            ResetThresholdData: ResetThresholdData,
            SaveThresholdBtnClick: SaveThresholdBtnClick,
            GreyOutCells: GreyOutCells,
            countEntry: ko.observable(0),
            ErrorStatus: ko.observable(0),
            PrevRAId: ko.observable(),
            FactorCountEntry: ko.observable(0),
            PrevFactorId: ko.observable(),
            InputChange: InputChange,
            InputChangeEvent: ko.observable(false),
            SaveButtonClick: ko.observable(false),
            ClickedRiskAreaType: ko.observable(),
            QualThresholdValuesList: ko.observableArray(),
            SaveQualitativeThresholdValues: SaveQualitativeThresholdValues,
            CurrentProfileOfAssessment: ko.observable(),
            ResetQualitativeThresholdValues: ResetQualitativeThresholdValues,
            onBlurEvent: onBlurEvent,
            onBlurMin: onBlurMin,
            AssessmentName: ko.observable(),

            // Tree View
            InitiateLevelTree: InitiateLevelTree,
            hasChildNodes: ko.observable(false),
            AreaLeveljstree: ko.observableArray([]),
            ClickedRAType: ko.observable(),
            SelectedScenarioId: ko.observable(),
            SelectedState: ko.observable(),
            GroupName: ko.observable(),
            QualThresholdValuesListDup: ko.observableArray([]),
            copyToAll: copyToAll,
            copyToAllFlag: ko.observable(0),
            ExpandAllTreeView: ExpandAllTreeView,
            CollapseAllTreeView: CollapseAllTreeView,

            GetSurveyCategoryTabs: GetSurveyCategoryTabs,
            SurveyCategoryListTh: ko.observableArray([]),
            SelectedAssessmentId: ko.observable(),
            SurveyCategoryModel: SurveyCategoryModel,
            SurveyCategoryTabClickTh: SurveyCategoryTabClickTh,
            SelectedSurveyComponentIdTh: ko.observable(),
            RiskAreaListTh: ko.observableArray(),
            SurveyTypeClicked: ko.observable(),
            OverallTabClick: OverallTabClick,
            GetOverallThresholdData: GetOverallThresholdData,
            OverallThresholdValuesList: ko.observableArray([]),
            OverallThresholdValuesListDup: ko.observableArray([]),

            ObjGeneralSettings: ObjGeneralSettings,
            LocaleCheckFlag: ko.observable(false),
        };

        return AtViewModel;

        function detached() {
            try {
                $($(document.getElementsByClassName('list-group-item')).get(4)).removeClass('active');
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: detached() method in VisualAnalyticsThresholds.js';
                logger.logMessage(msg);
            }
        }

        function attached() {
            try {
                if (AtViewModel.ObjGeneralSettings === undefined || AtViewModel.ObjGeneralSettings.LocalizedTextList() === undefined || ((AtViewModel.ObjGeneralSettings.LocalizedTextList() !== undefined || AtViewModel.ObjGeneralSettings.LocalizedTextList() !== null) && AtViewModel.ObjGeneralSettings.LocalizedTextList().length === 0)) {
                    AtViewModel.ObjGeneralSettings.GetLocalizedData().then(function () {
                        if (AtViewModel.ObjGeneralSettings.LocalizedTextList() == undefined || AtViewModel.ObjGeneralSettings.LocalizedTextList() == null || AtViewModel.ObjGeneralSettings.LocalizedTextList().length <= 0 || AtViewModel.ObjGeneralSettings.LocalizedIndexList() == undefined || AtViewModel.ObjGeneralSettings.LocalizedIndexList() == null)
                            AtViewModel.LocaleCheckFlag(false);
                        else
                            AtViewModel.LocaleCheckFlag(true);
                    });
                } else
                    AtViewModel.LocaleCheckFlag(true);

                if (AtViewModel.ObjGeneralSettings === undefined || AtViewModel.ObjGeneralSettings.LocalizedTextList() === undefined || ((AtViewModel.ObjGeneralSettings.LocalizedTextList() !== undefined || AtViewModel.ObjGeneralSettings.LocalizedTextList() !== null) && AtViewModel.ObjGeneralSettings.LocalizedTextList().length === 0)) {
                    AtViewModel.ObjGeneralSettings.GetLocalizedData().then(function () {
                        if (AtViewModel.ObjGeneralSettings.LocalizedTextList() == undefined || AtViewModel.ObjGeneralSettings.LocalizedTextList() == null || AtViewModel.ObjGeneralSettings.LocalizedTextList().length <= 0 || AtViewModel.ObjGeneralSettings.LocalizedIndexList() == undefined || AtViewModel.ObjGeneralSettings.LocalizedIndexList() == null)
                            AtViewModel.LocaleCheckFlag(false);
                        else
                            AtViewModel.LocaleCheckFlag(true);
                    });
                }


            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: attached() method in VisualAnalyticsThresholds.js';
                logger.logMessage(msg);
            }
        };

        function pageinvoke(TYPE, AssessmentName, StateSelected, SelectedScenarioId, SurveyGroupShortName) {
            try {
                AtViewModel.AssessmentType(TYPE);
                AtViewModel.SelectedState(StateSelected);

                AtViewModel.SelectedScenarioId(SelectedScenarioId);

                AtViewModel.countEntry(0);
                AtViewModel.FactorCountEntry(0);
                $($(document.getElementsByClassName('list-group-item')).get(4)).addClass('active');
                //InitiateLevelTree(SurveyGroupShortName);

                GetSurveyCategoryTabs(TYPE, StateSelected);

                var url = window.location.pathname;
                var filename = url.substring(url.lastIndexOf('/') + 1);

                $(document).on('change', 'input', function (e) {
                    var url = window.location.pathname;

                    var filename = url.substring(url.lastIndexOf('/') + 1);
                    if (filename == "InherentHeatMapAnalysis") {
                        Greyinput(e.currentTarget.id);
                    }
                });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: attached() method in VisualAnalyticsThresholds.js';
                logger.logMessage(msg);
            }
        }

        function GetSurveyCategoryTabs(AssessmentId, StateSelected) {
            try {
                $.ajax({
                    url: "/api/Visualization/GetSurveyCategoryTabsByZATRAT",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders(),
                    data: { "AssessmentId": AssessmentId, "StateSelected": StateSelected }
                })
                    .success(function (jsonResult, success) {
                        try {
                            if (jsonResult != null) {
                                var mappedTabList = $.map(jsonResult, function (result) {
                                    return new SurveyCategoryModel(result);
                                });
                                $('#loadingMainImgDivTh').show();
                                AtViewModel.SurveyCategoryListTh(mappedTabList);

                                $('#SurveyCategoryTabsDivTh').tabs({ active: 0 });
                                $($('#SurveyCategoryTabsDivTh li').get(0)).trigger('click');
                                scrollableTabs();
                            }
                            else {
                                $('#loadingMainImgDivTh').hide();
                                $('#errorMainTab').show();
                            }
                        }
                        catch (e) {
                            var msg = 'Exception: ' + e + ' | Source: GetSurveyCategoryTabs() Success method in AMLThresholds.js';
                            logger.logMessage(msg);
                        }

                    })
                    .fail(function (error, status) {
                        if (error.status == 401) {
                            app.showMessage(((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name())
                                , "Error in Edit Operation"
                                , [
                                    //((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name)
                                    ((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name())
                                ], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                .then(function (option) {
                                    if (option == ((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name()))
                                        navigation.unauthorized();
                                })
                        }
                        else {
                            var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetSurveyCategoryTabs() method in AMLThresholds.js';
                            logger.logMessage(msg);
                        }

                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetSurveyCategoryTabs() method in AMLThresholds.js';
                logger.logMessage(msg);
            }
        }

        function SurveyCategoryTabClickTh(data, event) {
            try {
                $("#saveEditButtons").hide();
                $('#FilterAreaAccordion').show();

                $('#SurveyCategoryTabsDivTh li').removeClass('active');
                $('#ParentTab_Thresholds_' + data.SurveyCategoryId()).addClass('active');

                AtViewModel.SelectedSurveyComponentIdTh(data.SurveyCategoryId());
                //if (data.SurveyCategoryName() == 'Quantitative') {
                if (data.SurveyGroupShortName() == 'QTDR') {
                    AtViewModel.ClickedRiskAreaType('QTDR');
                }
                else {
                    AtViewModel.ClickedRiskAreaType('QLDR');
                }
                AtViewModel.RiskAreaListTh([]);
                AtViewModel.SurveyTypeClicked(data.SurveyGroupShortName());
                if (data.SurveyCategoryId() === -999)
                    OverallTabClick(data, event);
                else
                    //                GetAllRiskAreas();
                    InitiateLevelTree(data.SurveyGroupShortName(), data.SurveyCategoryId());
                $('#loadingMainImgDivTh').hide();

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SurveyCategoryTabClickTh() method in AMLThresholds.js';
                logger.logMessage(msg);
            }
        }

        /**************************INITIATE TREE LEVEL START************************************/

        function InitiateLevelTree(SurveyGroupShortName, SurveyCategoryId) {
            try {

                AtViewModel.GroupName(SurveyGroupShortName);

                AtViewModel.ClickedRiskAreaType(SurveyGroupShortName);

                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();

                headers.__RequestVerificationToken = csrfToken;
                getJsTreeAreaLevel = {

                    url: "/api/Visualization/GetAllRiskAreas",
                    type: "GET",
                    data: { "RiskAreaType": AtViewModel.GroupName(), "SurveyCategoryID": SurveyCategoryId, "AssessmentTypes": AtViewModel.AssessmentType().toString()},
                    headers: headers
                };
                $.ajax(getJsTreeAreaLevel)
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in InitiateLevelTree() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                if (jsonResult != null) {
                    //implement js tree logic here
                    AtViewModel.AreaLeveljstree(jsonResult.AreaLevelsData);

                    var MappedJsTreeList = $.map(jsonResult.AreaLevelsData["#"], function (result) {
                        return new jsTreeModel(result);
                    });

                    $('#jsTreeAreaLevelThWIA').treeview({
                        data: MappedJsTreeList,
                        onNodeSelected: nodeClickEvent
                    });

                    var hasChildNodes = ko.utils.arrayFilter(MappedJsTreeList, function (i) { if (i.dead_node != 1) { return i; } }).length > 0
                    AtViewModel.hasChildNodes(hasChildNodes);

                    //for initial load expand for treeview

                    //$("#ExpandAll").trigger("click");
                    //$("#ExpandAll").trigger("click");
                    $("#jsTreeAreaLevelThWIA ul:first li:first").trigger("click");
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage(((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name()), "", [((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name())], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == ((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name()))
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in InitiateLevelTree() method in AMLThresholds.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in InitiateLevelTree() method in AMLThresholds.js';
                    logger.logMessage(msg);
                }
            }

            function filterJsTree(TreeStructure) {

                return TreeStructure.filter(
                    function (item) {
                        if (item.nodes != undefined && item.nodes.length > 0) {
                            item.nodes = filterJsTree(item.nodes);
                        }

                        if (item.showLevel == 1)
                            return true;
                        else
                            return false;

                    }
                );
            }

            function nodeClickEvent(event, node) {
                // Your logic goes here
                //AtViewModel.Type(node.RA_Type());
                AtViewModel.ClickedRiskFactorId(node.id);
                $('#jsTreeAreaLevelThWIA').treeview('selectNode', [node.nodeId, { silent: true }]);
                $('#DynamicHTMLDiv').html("");
                $('#QualContDynamicHTMLDiv').html("");
                //$('#loadingImgMain').modal('show');
                //AtViewModel.copyToAllFlag(0);
                $('#lblThresholdValidation').hide();

                AtViewModel.ClickedRiskAreaId(parseInt(node.id));
                AtViewModel.ClickedRiskFactorName($('<div/>').html(node.text).text());
                AtViewModel.ClickedRAType(node.RA_Type());

                if (AtViewModel.GroupName() == "QTDR" && AtViewModel.ClickedRAType() == "F") {
                    GetThresholdData();
                    $('#RfTabTh').show();
                    $('#QualitativeTabDivTh').hide();
                }
                else {
                    //GetQualThresholdData();

                    $('#QualitativeTabDivTh').show();
                    $('#RfTabTh').hide();
                    $('#qualfactordiv').hide();
                    $("#saveEditButtons").hide();

                    AtViewModel.ClickedRiskAreaName($('<div/>').html(node.text).text());
                    AtViewModel.ClickedRiskAreaId(node.id);
                    GetQualThresholdData(AtViewModel.ClickedRiskAreaId());

                }

                //if (AtViewModel.ClickedRiskAreaType() == 'QTDR' && AtViewModel.ClickedRAType() == 'F') {
                //    GetThresholdData();
                //    $('#RfTabTh').show();
                //    $('#QualitativeTabDivTh').hide();
                //}
                //else {
                //    $('#QualitativeTabDivTh').show();
                //    $('#loadingImgMainQualTh').show();
                //    $('#RfTabTh').hide();
                //    $('#qualfactordiv').hide();
                //    $("#saveEditButtons").hide();

                    AtViewModel.ClickedRiskAreaName($('<div/>').html(node.text).text());
                    AtViewModel.ClickedRiskAreaId(node.id);
                //    GetQualThresholdData(AtViewModel.ClickedRiskAreaId());
                //}

                //}


                function ajaxFail(error, status) {
                    try {
                        if (error.status == 401) {
                            app.showMessage(((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name()), "", [((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name())], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                .then(function (option) {
                                    if (option == ((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name()))
                                        navigation.unauthorized();
                                })
                        }
                        else {
                            var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllRiskAreas() method in SurveyResponsePage.js';
                            logger.logMessage(msg);
                        }
                    } catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllRiskAreas() method in SurveyResponsePage.js';
                        logger.logMessage(msg);
                    }
                };
            }

            function jsTreeModel(item) {
                var self = this;

                self.id = item.AreaLevelId.toString();
                self.text = item.AreaLevelName;
                if (AtViewModel.AreaLeveljstree()[self.id].length > 0) {
                    self.nodes = $.map(AtViewModel.AreaLeveljstree()[self.id], function (result) {
                        return new jsTreeModel(result);
                    });
                }
                self.state = { expanded: false };
                self.dead_node = item.DeadNode;
                self.assessmentTypeList = ko.observableArray(item.AssessmentTypeList);
                self.RA_Type = ko.observable(item.RA_Type);

            }
        }


        /**************************INITIATE TREE LEVEL END**************************************/


        //--------------------------------------------------------------------draw threshold table--------------------------------------------------------------------------
        function Greyinput(id) {
            try {
                var z = $('#' + id).val();
                if (z == 100) {
                    $('#' + id).addClass("grey");
                    $('#' + id).removeClass("whiteinput");
                }
                else {
                    $('#' + id).addClass("whiteinput");
                    $('#' + id).removeClass("grey");
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: Greyinput() method in VisualAnalyticsThresholds.js';
                logger.logMessage(msg);
            }
        }
        function GreyOutCells() {
            try {
                for (var i = 1; i < AtViewModel.ThresholdValuesList().length; i++) {
                    var x = AtViewModel.ThresholdValuesList()[i].IrlId()
                    for (var j = 0; j < AtViewModel.ThresholdChildList().length; j++) {
                        var y = AtViewModel.ThresholdChildList()[j].RiskLevelId()
                        var z = $('#' + y + '_' + x).val()
                        if (z == 100) {
                            $('#' + y + '_' + x).addClass("grey");
                            $('#' + y + '_' + x).removeClass("whiteinput");
                        }
                        else {
                            $('#' + y + '_' + x).addClass("whiteinput");
                            $('#' + y + '_' + x).removeClass("grey");
                        }

                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GreyOutCells() method in VisualAnalyticsThresholds.js';
                logger.logMessage(msg);
            }
        }
        function InputChange() {
            GreyOutCells();
            AtViewModel.InputChangeEvent(true);
        }


        function GetAllRiskAreas(AssessmentName, StateSelected) {
            try {
                AtViewModel.AssessmentName(AssessmentName + " " + StateSelected +
                    //"Risk Thresholds"
                    ((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskThresholds') == -1) ? 'Risk Thresholds' : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskThresholds')].Name())
                );
                $.ajax({
                    //url: "/api/AMLRiskAssessment/GetAllRiskAreas?RiskAreaType=" + AtViewModel.AssessmentType(),
                    url: "/api/Visualization/GetAllRiskAreas",
                    data: { "AssessmentType": AtViewModel.AssessmentType(), "AreaType": "ALL", "Profile": AtViewModel.CurrentProfileOfAssessment() },
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in GetAllRiskAreas() method in VisualAnalyticsThresholds.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult != null && jsonResult[0].RiskAreaName != null) {
                        var mappedRiskAreaList = $.map(jsonResult, function (result) {
                            return new RiskAreaModel(result);
                        });
                        AtViewModel.RiskAreaList(mappedRiskAreaList);
                        AtViewModel.countEntry(0);
                        $('#RaTHTab').tabs();
                        $('#RaTHTab').tabs('refresh');
                        $('#RaTHTab').tabs({ active: 0 });
                        $($('#RiskAreaTHUl li').get(0)).trigger('click');
                        scrollableTabs();
                    }
                    else if (jsonResult[0].RiskAreaName == null)
                        app.showMessage(
                            //"Risk Areas are not yet configured for this profile of assessment. Please configure the Risk Areas to before setting Thresholds"
                            ((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RAConfiguredProfileAssessment') == -1) ? 'Risk Areas are not yet configured for this profile of assessment. Please configure the Risk Areas to before setting Thresholds' : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RAConfiguredProfileAssessment')].Name())
                            //, "Error in Fetching Risk Areas"
                            , ((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FetchingAreasError') == -1) ? 'Error in Fetching Risk Areas' : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FetchingAreasError')].Name())
                            , [((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name())])
                            .then(function (option) {
                                if (option == ((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name()))
                                    router.navigate("configuration/RisksAreasfactors", true);
                            })
                    else
                        logger.logError(((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage') == -1) ? 'An error occurred. Please contact your Application Administrator.' : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage')].Name()), 'Error', system.getModuleId(AtViewModel), true);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllRiskAreas() method in VisualAnalyticsThresholds.js';
                    logger.logMessage(msg);
                }
            };

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage(((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name()), "Error in Edit Operation", [((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name())], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == ((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name()))
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllRiskAreas() method in VisualAnalyticsThresholds.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllRiskAreas() method in VisualAnalyticsThresholds.js';
                    logger.logMessage(msg);
                }
            };
        }

        function GetAllRiskFactors() {
            try {
                AtViewModel.PrevRAId(AtViewModel.ClickedRiskAreaId());
                $.ajax({
                    url: "/api/Configuration/GetAllRiskfactorAreaWise",
                    data: { "RiskAreaId": AtViewModel.ClickedRiskAreaId(), "AssessmentType": AtViewModel.AssessmentType() },
                    type: "GET",
                    async: false,
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in GetAllRiskFactors() method in VisualAnalyticsThresholds.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult.length == 0) {
                        AtViewModel.RiskFactorList([])
                        if ($('#RiskAreaTabDivForThresholds').is(":visible")) {
                            $('#RiskAreaTabDivForThresholds').hide();
                        }
                        $('#RiskAreaTabDivForThresholds').hide();
                        $('#Factorerror').css('display', "block");

                    }
                    else if (jsonResult != null && jsonResult[0].RiskFactorName != null) {
                        $('#Factorerror').hide();
                        var mappedRiskFactorList = $.map(jsonResult, function (result) {
                            return new RiskFactorModel(result);
                        });
                        AtViewModel.RiskFactorList(mappedRiskFactorList);

                        $('#RfTab').tabs();
                        $('#RfTab').tabs('refresh');
                        $('#RfTab').tabs({ active: 0 });
                        $($('#RiskFactorUl li').get(0)).trigger('click');
                    }
                    else if (jsonResult[0].RiskFactorName == null)
                        app.showMessage(
                            //"Risk Factors are not yet configured for this year of assessment. Please configure the Risk Factors to before setting Thresholds."
                            ((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskFactorsNotConfigured') == -1) ? 'Risk Factors are not yet configured for this year of assessment. Please configure the Risk Factors to before setting Thresholds.' : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskFactorsNotConfigured')].Name())
                            //, "Risk Factors not configured."
                            , ((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RFNotConfigured') == -1) ? 'Risk Factors not configured.' : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RFNotConfigured')].Name())
                            , [((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name())])
                            .then(function (option) {
                                if (option == ((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name()))
                                    router.navigate("configuration/RisksAreasfactors", true);
                            })
                    else
                        logger.logError(((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage') == -1) ? 'An error occurred. Please contact your Application Administrator.' : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage')].Name()), 'Error', system.getModuleId(AtViewModel), true);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllRiskFactors() method in VisualAnalyticsThresholds.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage(((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name()), "Error in Edit Operation", [((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name())], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == ((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name()))
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllRiskFactors() method in VisualAnalyticsThresholds.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllRiskFactors() method in AMLInherentRiskAssessment.js';
                    logger.logMessage(msg);
                }
            }
        }

        function RiskAreaTabClick(data, event) {
            try {
                if (data.IsQualitative() == "0") {
                    $('#QualitativeTabDiv').hide();
                    $('#loadingImgMainQual').hide();
                    $('#RfTab').show();

                    if (AtViewModel.appsecurity.WriteAccess() == false || AtViewModel.appsecurity.WriteAccess() == "false") {
                        AtViewModel.countEntry(0);
                        AtViewModel.FactorCountEntry(0);
                    }
                    if (AtViewModel.countEntry() == 0) {
                        AtViewModel.countEntry(1);
                        $('#lblThresholdValidation').hide();
                        AtViewModel.ClickedRiskAreaId(data.RiskAreaId());
                        AtViewModel.ClickedRiskAreaName(data.RiskAreaName());
                        GetAllRiskFactors();
                    }
                    else if (AtViewModel.InputChangeEvent() && AtViewModel.SaveButtonClick() == false) {
                        AtViewModel.InputChangeEvent(false);
                        app.showMessage(
                            //"Please save the data before moving to other tab, otherwise the changes made will be lost."
                            ((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DirtyDataCheckAreaTab') == -1) ? 'Please save the data before moving to other tab, otherwise the changes made will be lost.' : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DirtyDataCheckAreaTab')].Name())
                            , "Warning"
                            , [
                                //"Save"
                                ((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SaveButton') == -1) ? "Save" : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SaveButton')].Name())
                                ,
                                //"Cancel"
                                ((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CancelButton') == -1) ? "Cancel" : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CancelButton')].Name())
                            ], true, { buttonClass: "fa fa-check btn btn-danger", primaryButtonClass: "fa fa-check btn btn-success autofocus" })
                            .then(function (option) {
                                if (option == ((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SaveButton') == -1) ? "Save" : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SaveButton')].Name())) {
                                    $('#btnSaveThreshold').click();
                                    AtViewModel.countEntry(0);
                                    AtViewModel.FactorCountEntry(0);
                                    if (AtViewModel.ErrorStatus() == 1) {
                                        AtViewModel.ErrorStatus(0);
                                        $('#' + AtViewModel.PrevRAId()).addClass('ui-tabs-active ui-state-active');
                                        $('#' + data.RiskAreaId()).removeClass('ui-tabs-active ui-state-active');
                                    }
                                    else {
                                        AtViewModel.SaveButtonClick(false);
                                        AtViewModel.countEntry(0);
                                        $('#lblThresholdValidation').hide();
                                        $('#' + AtViewModel.PrevRAId()).removeClass('ui-tabs-active ui-state-active');
                                        $('#' + data.RiskAreaId()).addClass('ui-tabs-active ui-state-active');
                                        RiskAreaTabClick(data, event);
                                    }
                                }
                                else {
                                    //AtViewModel.WeightingsType('');
                                    AtViewModel.countEntry(1);
                                    $('#lblThresholdValidation').hide();
                                    AtViewModel.FactorCountEntry(0);
                                    $('#' + AtViewModel.PrevRAId()).removeClass('ui-tabs-active ui-state-active');
                                    $('#' + data.RiskAreaId()).addClass('ui-tabs-active ui-state-active');
                                    AtViewModel.ClickedRiskAreaId(data.RiskAreaId());
                                    AtViewModel.ClickedRiskAreaName(data.RiskAreaName());
                                    GetAllRiskFactors();
                                }
                            })
                    }
                    else {
                        //AtViewModel.SaveButtonClick(false);
                        AtViewModel.InputChangeEvent(false);
                        AtViewModel.countEntry(0);
                        $('#' + AtViewModel.PrevRAId()).removeClass('ui-tabs-active ui-state-active');
                        $('#' + data.RiskAreaId()).addClass('ui-tabs-active ui-state-active');
                        RiskAreaTabClick(data, event);

                    }
                }
                else {
                    if (data.IsQualitative() == "1")
                        $('#QualitativeTabDiv').show();
                    $('#loadingImgMainQual').show();
                    $('#RfTab').hide();
                    $('#qualfactordiv').hide();
                    AtViewModel.ClickedRiskAreaName(data.RiskAreaName());
                    AtViewModel.ClickedRiskAreaId(data.RiskAreaId());
                    AtViewModel.ClickedRiskAreaType(data.RiskAreaType());
                    GetQualThresholdData(data);



                }

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: RiskAreaTabClick() method in VisualAnalyticsThresholds.js';
                logger.logMessage(msg);
            }
        }

        function RiskFactorTabClick(data, event) {
            try {
                if (AtViewModel.appsecurity.WriteAccess() == false || AtViewModel.appsecurity.WriteAccess() == "false") {
                    AtViewModel.FactorCountEntry(0);
                }
                if (AtViewModel.FactorCountEntry() == 0) {
                    AtViewModel.FactorCountEntry(1);
                    $('#loadingImgMain').show();
                    $('#FactorDataDiv').hide();
                    $('#lblThresholdValidation').hide();
                    AtViewModel.ClickedRiskFactorId(data.RiskFactorId());
                    AtViewModel.ClickedRiskFactorName(data.RiskFactorName());
                    $('#' + AtViewModel.PrevFactorId()).removeClass('ui-tabs-active ui-state-active');
                    $('#' + data.RiskFactorId()).addClass('ui-tabs-active ui-state-active');
                    GetThresholdData();
                }
                else if (AtViewModel.InputChangeEvent() && AtViewModel.SaveButtonClick() == false) {
                    AtViewModel.InputChangeEvent(false);
                    app.showMessage(
                        //"Please save the data before moving to another tab, otherwise the changes made will be lost."
                        ((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DirtyDataCheckAreaTab') == -1) ? 'Please save the data before moving to other tab, otherwise the changes made will be lost.' : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DirtyDataCheckAreaTab')].Name())
                        , "Warning"
                        , [                                //"Save"
                            ((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SaveButton') == -1) ? "Save" : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SaveButton')].Name())
                            ,
                            //"Cancel"
                            ((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CancelButton') == -1) ? "Cancel" : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CancelButton')].Name())
                        ]
                        , true, { buttonClass: "fa fa-check btn btn-danger", primaryButtonClass: "fa fa-check btn btn-success autofocus" })
                        .then(function (option) {
                            if (option == "Save") {
                                $('#btnSaveThreshold').click();
                                AtViewModel.FactorCountEntry(0);
                                if (AtViewModel.ErrorStatus() == 1) {
                                    AtViewModel.ErrorStatus(0);
                                    $('#' + AtViewModel.PrevFactorId()).addClass('ui-tabs-active ui-state-active');
                                    $('#' + data.RiskFactorId()).removeClass('ui-tabs-active ui-state-active');
                                }
                                else {
                                    AtViewModel.SaveButtonClick(false);
                                    AtViewModel.FactorCountEntry(0);
                                    $('#' + AtViewModel.PrevFactorId()).removeClass('ui-tabs-active ui-state-active');
                                    $('#' + data.RiskFactorId()).addClass('ui-tabs-active ui-state-active');
                                    RiskFactorTabClick(data, event);
                                }
                            }
                            else {
                                //AtViewModel.WeightingsType('');
                                AtViewModel.FactorCountEntry(1);
                                $('#lblThresholdValidation').hide();
                                $('#' + AtViewModel.PrevFactorId()).removeClass('ui-tabs-active ui-state-active');
                                $('#' + data.RiskFactorId()).addClass('ui-tabs-active ui-state-active');
                                $('#loadingImgMain').show();
                                $('#FactorDataDiv').hide();
                                AtViewModel.ClickedRiskFactorId(data.RiskFactorId());
                                AtViewModel.ClickedRiskFactorName(data.RiskFactorName());
                                GetThresholdData();
                            }
                        })
                }
                else {
                    AtViewModel.InputChangeEvent(false);
                    AtViewModel.SaveButtonClick(false);
                    AtViewModel.FactorCountEntry(0);
                    $('#' + AtViewModel.PrevFactorId()).removeClass('ui-tabs-active ui-state-active');
                    $('#' + data.RiskFactorId()).addClass('ui-tabs-active ui-state-active');
                    RiskFactorTabClick(data, event);
                }
                //$('#loadingImgMain').show();
                //$('#FactorDataDiv').hide();
                //AtViewModel.ClickedRiskFactorId(data.RiskFactorId());
                //AtViewModel.ClickedRiskFactorName(data.RiskFactorName());
                //GetThresholdData();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: RiskFactorTabClick() method in VisualAnalyticsThresholds.js';
                logger.logMessage(msg);
            }
        }

        /*
        function GetThresholdData() {
            try {
                AtViewModel.PrevFactorId(AtViewModel.ClickedRiskFactorId());
                $.ajax({
                    url: "/api/Visualization/GetFactorThreshold?RiskFactorId=" + AtViewModel.ClickedRiskFactorId() + "&AssessmentType=" + AtViewModel.AssessmentType() + "&TableType=F &ProfileId=" + AtViewModel.CurrentProfileOfAssessment(),
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetThresholdData() method in VisualAnalyticsThresholds.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                try {
                    $('#loadingImgMain').hide();
                    $('#FactorDataDiv').show();
                    var MappedThresholdValue = $.map(jsonResult, function (result) {
                        return new ThresholdValueModel(result);
                    });
                    $('#tblThreshold tbody tr').remove();
                    AtViewModel.ThresholdValuesList(MappedThresholdValue);

                    var MappedThresholdValueDup = $.map(jsonResult, function (result) {
                        return new ThresholdValueModel(result);
                    });
                    AtViewModel.ThresholdValuesListDup(MappedThresholdValueDup);

                    AtViewModel.ThresholdChildList(AtViewModel.ThresholdValuesList()[0].ChildList());
                    GreyOutCells();
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetThresholdData() method in VisualAnalyticsThresholds.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage(((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name), "Error in Edit Operation", [((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name)], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == ((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name))
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetThresholdData() method in VisualAnalyticsThresholds.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail  in GetThresholdData() method in VisualAnalyticsThresholds.js';
                    logger.logMessage(msg);
                }
            }
        }
        */

        function GetThresholdData() {
            try {
                AtViewModel.PrevFactorId(AtViewModel.ClickedRiskFactorId());
                $.ajax({
                    url: "/api/Visualization/GetFactorThreshold?TableId=" + AtViewModel.ClickedRiskFactorId() + "&AssessmentType=" + AtViewModel.AssessmentType() +
                        "&TableType=" + AtViewModel.ClickedRAType() + "&SurveyCategoryId=" + AtViewModel.SelectedSurveyComponentIdTh() + "&ScenarioId=" + AtViewModel.SelectedScenarioId(),
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetThresholdData() method in VisualanalyticsThresholds.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult == 0 || jsonResult == null) {
                        $('#loadingImgMainTh').hide();
                        $('#FactorDataDivTh').show();
                        $('#NoDataErrorThresholds').show();
                    }
                    else {
                        $('#NoDataErrorThresholds').hide();
                        $('#loadingImgMainTh').hide();
                        $('#FactorDataDivTh').show();
                        var MappedThresholdValue = $.map(jsonResult, function (result) {
                            return new ThresholdValueModel(result);
                        });
                        $('#tblThreshold tbody tr').remove();

                        AtViewModel.ThresholdValuesList([]);
                        AtViewModel.ThresholdValuesList(MappedThresholdValue);

                        var MappedThresholdValueDup = $.map(jsonResult, function (result) {
                            return new ThresholdValueModel(result);
                        });
                        AtViewModel.ThresholdValuesListDup([]);
                        AtViewModel.ThresholdValuesListDup(MappedThresholdValueDup);

                        AtViewModel.QualThresholdValuesList([]);
                        AtViewModel.QualThresholdValuesListDup([]);

                        AtViewModel.ThresholdChildList([]);
                        AtViewModel.ThresholdChildList(AtViewModel.ThresholdValuesList()[0].ChildList());
                        GreyOutCells();

                        //if (AtViewModel.ComposeBindingFlag()) {
                        //    $("#btnSaveThreshold").hide();
                        //    $("#btnCancelThreshold").hide();
                        //    $("#btnSaveThreshold1").hide();
                        //    $("#btnCancelThreshold1").hide();

                        //}
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetThresholdData() method in VisualanalyticsThresholds.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage(((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name()), "Error in Edit Operation", [((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name())], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == ((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name()))
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetThresholdData() method in VisualanalyticsThresholds.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail  in GetThresholdData() method in VisualanalyticsThresholds.js';
                    logger.logMessage(msg);
                }
            }
        }


        function GetQualThresholdData(data) {
            try {
                $.ajax({
                    url: "/api/Visualization/GetQualFactorThreshold",
                    data: {
                        "TableId": parseInt(data), "AssessmentType": AtViewModel.AssessmentType(), "TableType": "A", "SurveyCategoryId": AtViewModel.SelectedSurveyComponentIdTh(), "ScenarioId": AtViewModel.SelectedScenarioId()
                    },
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetQualThresholdData() method in VisualanalyticsThresholds.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult == 0 || jsonResult == null) {
                        $('#qualfactordiv').show();
                        $("#saveEditButtons").show();
                        $('#NoDataErrorQualThresholds').show();
                    }
                    else {
                        $('#NoDataErrorQualThresholds').hide();
                        $("#error").hide();
                        $('#qualfactordiv').show();
                        $("#saveEditButtons").show();
                        var MappedQualThresholdValue = $.map(jsonResult, function (result) {
                            return new QualThresholdValueModel(result);
                        });
                        $('#tblThreshold tbody tr').remove();
                        AtViewModel.QualThresholdValuesList(MappedQualThresholdValue);

                        var MappedThresholdValueDup = $.map(jsonResult, function (result) {
                            return new QualThresholdValueModel(result);
                        });
                        AtViewModel.QualThresholdValuesListDup(MappedThresholdValueDup);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetQualThresholdData() method in VisualanalyticsThresholds.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage(((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name()), "Error in Edit Operation", [((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name())], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == ((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name()))
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetQualThresholdData() method in VisualanalyticsThresholds.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail  in GetQualThresholdData() method in VisualanalyticsThresholds.js';
                    logger.logMessage(msg);
                }
            }
        }



        function ThresholdCellBlur(data, event) {
            try {
                var RiskLevelId = event.currentTarget.parentNode.parentNode.id;
                var Value = event.currentTarget.value;
                ValidateThresholdValues(data.IrlId(), RiskLevelId, Value);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ThresholdCellBlur() method in VisualAnalyticsThresholds.js';
                logger.logMessage(msg);
            }
        }

        function ValidateThresholdValues(IrlId, RiskLevelId, Value) {
            try {
                var Result = false;
                var ColumnIndex = 0;
                var RowIndex = 0;
                for (var i = 0; i < $('#tblThreshold thead tr th').length; i++) {
                    if ($('#tblThreshold thead tr th').get(i).id == IrlId)
                        ColumnIndex = i;
                }
                ColumnIndex = (ColumnIndex * 2) + 1;
                for (var i = 0; i < $('#tblThreshold tbody tr').length; i++) {
                    if ($($('#tblThreshold tbody tr').get(i)).find('td').get(ColumnIndex).id == RiskLevelId)
                        RowIndex = i;
                }
                var ErrorMsg = "";

                if (Value == "" || Value == undefined) {
                    ErrorMsg = "Value cannot be left blank";
                    $($($('#tblThreshold tbody tr').get(RowIndex)).find('td').get(ColumnIndex)).find('input').css("border", "1px solid red");
                }
                else if (isNaN(Value)) {
                    ErrorMsg = "Non-Numeric Value is not allowed";
                    $($($('#tblThreshold tbody tr').get(RowIndex)).find('td').get(ColumnIndex)).find('input').css("border", "1px solid red");
                }
                else if (Value < 0 || Value > 100) {
                    ErrorMsg = "Value should be in range 0 - 100";
                    $($($('#tblThreshold tbody tr').get(RowIndex)).find('td').get(ColumnIndex)).find('input').css("border", "1px solid red");
                }
                else {
                    if ((parseFloat(Value).toString().indexOf('.') < 0) ? true : ((parseFloat(Value).toString().split('.')[1].length <= 2) ? true : false)) {
                        $($($('#tblThreshold tbody tr').get(RowIndex)).find('td').get(ColumnIndex)).find('input').removeAttr('style');
                        ErrorMsg = "";
                        Result = true;
                    }
                    else {
                        ErrorMsg = "Decimal Upto Only 2 Places is Allowed";
                        $($($('#tblThreshold tbody tr').get(RowIndex)).find('td').get(ColumnIndex)).find('input').css("border", "1px solid red");
                    }
                }
                if (ErrorMsg.length > 0) {
                    AtViewModel.ErrorStatus(1);
                }
                $($($('#tblThreshold tbody tr').get(RowIndex)).find('td').get(ColumnIndex)).find('label').text(ErrorMsg);
                return Result;
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ValidateThresholdValues() method in VisualAnalyticsThresholds.js';
                logger.logMessage(msg);
            }
        }

        function ConvertObservableToObject(Data) {
            try {
                var ThresholdValue = new Array();
                for (var i = 0; i < Data().length; i++) {
                    var Child = new Array();
                    for (j = 0; j < Data()[i].ChildList().length; j++) {
                        Child.push(new Object({
                            RiskLevelId: Data()[i].ChildList()[j].RiskLevelId(),
                            RiskLevelName: Data()[i].ChildList()[j].RiskLevelName(),
                            RiskLevelCss: Data()[i].ChildList()[j].RiskLevelCss()
                        }));
                    }
                    ThresholdValue.push(new Object({
                        IrlId: Data()[i].IrlId(),
                        IrlName: Data()[i].IrlName(),
                        Child: Child
                    }));
                }
                return ThresholdValue;
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ConvertObservableToObject() method in VisualAnalyticsThresholds.js';
                logger.logMessage(msg);
            }
        }

        function ResetThresholdData() {
            try {
                for (var i = 1; i < AtViewModel.ThresholdValuesListDup().length; i++) {
                    for (var j = 0; j < AtViewModel.ThresholdValuesListDup()[i].ChildList().length; j++) {
                        var Value = AtViewModel.ThresholdValuesListDup()[i].ChildList()[j].RiskLevelName();
                        AtViewModel.ThresholdValuesList()[i].ChildList()[j].RiskLevelName(Value);
                    }
                }
                $('#tblThreshold tbody input').removeAttr('style');
                $('#tblThreshold tbody #lblValidation').text("");
                $('#lblThresholdValidation').text("");
                $('#lblThresholdValidation').hide();
                GreyOutCells();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ResetThresholdData() method in VisualAnalyticsThresholds.js';
                logger.logMessage(msg);
            }
        }

        function SaveThresholdBtnClick() {
            try {
                AtViewModel.SaveButtonClick(true);
                var Counter = 0;
                for (var i = 1; i < AtViewModel.ThresholdValuesList().length; i++) {
                    for (var j = 0; j < AtViewModel.ThresholdValuesList()[i].ChildList().length; j++) {
                        if (!(ValidateThresholdValues(AtViewModel.ThresholdValuesList()[i].IrlId(), AtViewModel.ThresholdValuesList()[i].ChildList()[j].RiskLevelId(), AtViewModel.ThresholdValuesList()[i].ChildList()[j].RiskLevelName())))
                            Counter++;
                    }
                }
                if (Counter == 0) {
                    $('#lblThresholdValidation').text("");
                    $('#lblThresholdValidation').hide();
                    var ObjectData = ConvertObservableToObject(AtViewModel.ThresholdValuesList);
                    SaveThresholdValues(ObjectData);
                }
                else {
                    $('#lblThresholdValidation').text("Please correct the errors highlighted in below cells before saving the Threshold Data.");
                    $('#lblThresholdValidation').show();
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SaveThresholdBtnClick() method in VisualAnalyticsThresholds.js';
                logger.logMessage(msg);
            }
        }

        function CollapseAllTreeView() {
            if ($('#spanExpandAll').text() ==
                //"Expand"
                ((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ExpandButton') == -1) ? 'Expand' : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ExpandButton')].Name())
            ) {
                $('#jsTreeAreaLevelThWIA').treeview('collapseAll', { silent: true });
                $("#spanExpandAll").text(
                    //"Collapse"
                    ((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CollapseButton') == -1) ? 'Collapse' : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CollapseButton')].Name())
                );
            }
            else {
                $('#jsTreeAreaLevelThWIA').treeview('expandAll', { silent: true });
                $("#spanExpandAll").text(
                    //"Expand"
                    ((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ExpandButton') == -1) ? 'Expand' : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ExpandButton')].Name())
                );
            }
        }

        function ExpandAllTreeView() {
            $('#jsTreeAreaLevelThWIA').treeview('expandAll', { silent: true });
        }


        function SaveThresholdValues(ObjectData) {
            try {

                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Visualization/saveFactorThreshold?TableId=" + AtViewModel.ClickedRiskFactorId() + "&AssessmentType=" + AtViewModel.AssessmentType() +
                        "&TableType=F&SurveyCategoryId=" + AtViewModel.SelectedSurveyComponentIdTh() + "&copyFlag=" + AtViewModel.copyToAllFlag() + "&ScenarioId=" + AtViewModel.SelectedScenarioId(),
                    headers: headers,
                    type: "POST",
                    contentType: 'application/json',
                    dataType: 'json',
                    data: JSON.stringify(ObjectData)
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in SaveThresholdValues() method in AMLThreshold.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                try {
                    AtViewModel.copyToAllFlag(0);
                    if (jsonResult == 1) {
                        for (var i = 1; i < AtViewModel.ThresholdValuesList().length; i++) {
                            for (var j = 0; j < AtViewModel.ThresholdValuesList()[i].ChildList().length; j++) {
                                var Value = AtViewModel.ThresholdValuesList()[i].ChildList()[j].RiskLevelName();
                                AtViewModel.ThresholdValuesListDup()[i].ChildList()[j].RiskLevelName(Value);
                            }
                        }
                        logger.logSuccess(
                            //'Threshold Data saved successfully.'
                            ((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ThresholdsSaveSuccess') == -1) ? "Threshold Data saved successfully." : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ThresholdsSaveSuccess')].Name())
                            , 'Success', system.getModuleId(AtViewModel), true);
                    }
                    else
                        logger.logError(((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage') == -1) ? 'An error occurred. Please contact your Application Administrator.' : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage')].Name()), 'Error', system.getModuleId(AtViewModel), true);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in SaveThresholdValues() method in AMLThreshold.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    AtViewModel.copyToAllFlag(0);
                    if (error.status == 401) {
                        app.showMessage(((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name()), "Error in Edit Operation", [((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name())], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == ((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name()))
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in SaveThresholdValues() method in AMLThreshold.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail  in SaveThresholdValues() method in AMLThreshold.js';
                    logger.logMessage(msg);
                }
            }
        }

        //------------------------------------------------------------Qualtiative Thresholds starts here--------------------------------------------
        function ValidateThresholdsValues(data) {
            var validation = true;
            if (AtViewModel.SelectedSurveyComponentIdTh() === -999) {
                $.each(AtViewModel.OverallThresholdValuesList(), function (index, value) {
                    var level = value.Level();
                    if (parseFloat(value.Min()) >= parseFloat(value.Max())) {
                        value.ShouldShowMessage(true);
                        value.ValidationMessage(
                            //"Max should be more then Min"
                            ((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('MaxGreaterThanMin') == -1) ? "Max should be more then Min" : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('MaxGreaterThanMin')].Name())
                        );
                        validation = false;
                    }
                    else if (value.ShouldShowMessage()) {
                        value.ShouldShowMessage(false);
                        value.ValidationMessage(null);
                        validation = true;
                    }
                });
            }
            else {
                $.each(AtViewModel.QualThresholdValuesList(), function (index, value) {
                    var level = value.Level();
                    if (parseFloat(value.Min()) >= parseFloat(value.Max())) {
                        value.ShouldShowMessage(true);
                        value.ValidationMessage(
                            //"Max should be more then Min"
                            ((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('MaxGreaterThanMin') == -1) ? "Max should be more then Min" : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('MaxGreaterThanMin')].Name())
                        );
                        validation = false;
                    }
                    else if (value.ShouldShowMessage()) {
                        value.ShouldShowMessage(false);
                        value.ValidationMessage(null);
                        validation = true;
                    }
                });
            }
            return validation;
        }


        function SaveQualitativeThresholdValues(data) {
            try {
                var jsonString = "";
                var copyFlag = AtViewModel.copyToAllFlag();
                var TableId = AtViewModel.ClickedRiskAreaId();

                var ValidFlag = 1;

                for (var i = 0; i < AtViewModel.QualThresholdValuesList().length; i++) {
                    if (AtViewModel.QualThresholdValuesList()[i].Max() == '') {
                        ValidFlag = 0;
                    }
                }

                if (ValidFlag == 1) {


                    var TableType = "";
                    if (AtViewModel.SelectedSurveyComponentIdTh() === -999) {
                        jsonString = $.map(AtViewModel.OverallThresholdValuesList(), function (result) {
                            return {
                                Uid: result.Uid(),
                                FinalRiskId: result.FinalRiskId(),
                                Min: result.Min(),
                                Max: result.Max(),
                                Description: result.Description(),
                                Level: result.Level(),
                                Css: result.CSS()
                            }
                        });
                        TableId = 0;
                        TableType = "B";
                    }
                    else {
                        jsonString = $.map(AtViewModel.QualThresholdValuesList(), function (result) {
                            return {
                                Uid: result.Uid(),
                                FinalRiskId: result.FinalRiskId(),
                                Min: result.Min(),
                                Max: result.Max(),
                                Description: result.Description(),
                                Level: result.Level(),
                                Css: result.CSS()
                            }
                        });
                        TableType = "A";
                    }

                    if (ValidateThresholdsValues(data)) {
                        var csrfToken = $("input[name='__RequestVerificationToken']").val();
                        var headers = appsecurity.getSecurityHeaders();
                        headers.__RequestVerificationToken = csrfToken;
                        $.ajax({
                            url: "/api/Visualization/saveFactorThreshold?TableId=" + TableId + "&AssessmentType=" + AtViewModel.AssessmentType() +
                                "&TableType=" + TableType + "&SurveyCategoryId=" + AtViewModel.SelectedSurveyComponentIdTh() + "&CopyFlag=" + copyFlag + "&ScenarioId=" + AtViewModel.SelectedScenarioId(),
                            headers: headers,
                            traditional: true,
                            type: "POST",
                            contentType: 'application/json',
                            dataType: 'json',
                            data: JSON.stringify(jsonString)
                        })
                            .success(ajaxSuccess)
                            .fail(ajaxFail);
                    }
                }
                else {
                    GetQualThresholdData(AtViewModel.ClickedRiskAreaId());
                    logger.logError(
                        //'Please enter valid Numeric Values.'
                        ((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EnterValidNumeric') == -1) ? "Please enter valid Numeric Values." : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EnterValidNumeric')].Name())
                        , 'Error', system.getModuleId(AtViewModel), true);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in SaveQualitativeThresholdValues() method in AMLThreshold.js';
                logger.logMessage(msg);
            }


            function ajaxSuccess(jsonResult, status) {
                try {
                    AtViewModel.copyToAllFlag(0);
                    if (jsonResult == 1) {
                        if (AtViewModel.SelectedSurveyComponentIdTh() === -999)
                            GetOverallThresholdData();
                        else
                            GetQualThresholdData(AtViewModel.ClickedRiskAreaId());
                        logger.logSuccess(
                            //'Qualitative Threshold Data saved successfully.'
                            ((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('QualThresholdsSaveSuccess') == -1) ? "Qualitative Threshold Data saved successfully." : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('QualThresholdsSaveSuccess')].Name())
                            , 'Success', system.getModuleId(AtViewModel), true);

                    }
                    else
                        logger.logError(((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage') == -1) ? 'An error occurred. Please contact your Application Administrator.' : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage')].Name()), 'Error', true);

                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in SaveQualitativeThresholdValues() method in AMLThreshold.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    AtViewModel.copyToAllFlag(0);
                    if (error.status == 401) {
                        app.showMessage(((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name()), "Error in Edit Operation", [((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name())], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == ((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name()))
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in SaveQualitativeThresholdValues() method in AMLThreshold.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail  in SaveQualitativeThresholdValues() method in AMLThreshold.js';
                    logger.logMessage(msg);
                }
            }
        }



        //function GetQualThresholdData(data) {
        //    try {
        //        $.ajax({
        //            url: "/api/Visualization/GetQualFactorThreshold",
        //            data: { "RiskAreaId": AtViewModel.ClickedRiskAreaId(), "AssessmentType": AtViewModel.AssessmentType(), "ProfileId": AtViewModel.CurrentProfileOfAssessment() },
        //            type: "GET",
        //            headers: appsecurity.getSecurityHeaders()
        //        })
        //            .success(ajaxSuccess)
        //            .fail(ajaxFail);
        //    }
        //    catch (e) {
        //        var msg = 'Exception: ' + e + ' | Source: GetQualThresholdData() method in VisualanalyticsThresholds.js';
        //        logger.logMessage(msg);
        //    }

        //    function ajaxSuccess(jsonResult, status) {
        //        try {
        //            $("#error").hide();
        //            $('#loadingImgMainQual').hide();
        //            $('#qualfactordiv').show();
        //            var MappedQualThresholdValue = $.map(jsonResult, function (result) {
        //                return new QualThresholdValueModel(result);
        //            });
        //            $('#tblThreshold tbody tr').remove();
        //            AtViewModel.QualThresholdValuesList(MappedQualThresholdValue);

        //            var MappedThresholdValueDup = $.map(jsonResult, function (result) {
        //                return new QualThresholdValueModel(result);
        //            });
        //        }
        //        catch (e) {
        //            var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetQualThresholdData() method in VisualanalyticsThresholds.js';
        //            logger.logMessage(msg);
        //        }
        //    }

        //    function ajaxFail(error, status) {
        //        try {
        //            if (error.status == 401) {
        //                app.showMessage(((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name), "Error in Edit Operation", [((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name)], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
        //                    .then(function (option) {
        //                        if (option == ((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name))
        //                            navigation.unauthorized();
        //                    })
        //            }
        //            else {
        //                var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetQualThresholdData() method in VisualanalyticsThresholds.js';
        //                logger.logMessage(msg);
        //            }
        //        }
        //        catch (e) {
        //            var msg = 'Exception: ' + e + ' | Source: ajaxFail  in GetQualThresholdData() method in VisualanalyticsThresholds.js';
        //            logger.logMessage(msg);
        //        }
        //    }
        //}

        function ResetQualitativeThresholdValues(data) {
            GetQualThresholdData(AtViewModel.ClickedRiskAreaId());
        }

        function onKeyPressvalidateNumber(data, event) {
            var charCode = (event.which) ? event.which : event.keyCode;
            if (charCode != 46 && charCode > 31
                && (charCode < 48 || charCode > 57))
                return false;
            return true;

        }

        function onBlurMin(data) {
            var level = data.Level() - 1;
            if ($.isNumeric(data.Min())) {
                if (AtViewModel.SelectedSurveyComponentIdTh() === -999) { // Survey Category for Overall is -999
                    for (var i = 0; i < AtViewModel.OverallThresholdValuesList().length; i++) {
                        var comp = AtViewModel.OverallThresholdValuesList()[i];
                        if (comp.Level() == (level)) {
                            if (Number(data.Min()) < Number(comp.Max())) {
                                data.ShouldShowMessageMin(true);
                                data.ValidationMessageMin(
                                    //"Min should be more than Max of previous level"
                                    ((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Min should be more than Max of previous level') == -1) ? "Min should be more than Max of previous level" : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Min should be more than Max of previous level')].Name())
                                );
                                return;
                            }

                        }
                    }

                }
                else {
                    for (var i = 0; i < AtViewModel.QualThresholdValuesList().length; i++) {
                        var comp = AtViewModel.QualThresholdValuesList()[i];
                        if (comp.Level() == (level)) {
                            if (Number(data.Min()) < Number(comp.Max())) {
                                data.ShouldShowMessageMin(true);
                                data.ValidationMessageMin(
                                    //"Min should be more than Max of previous level"
                                    ((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Min should be more than Max of previous level') == -1) ? "Min should be more than Max of previous level" : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Min should be more than Max of previous level')].Name())
                                );
                                return;
                            }

                        }
                    }
                }
                if (Number(data.Min()) >= Number(data.Max())) {
                    data.ShouldShowMessageMin(true);
                    data.ValidationMessageMin(
                        //"Min should be less than Max"
                        ((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('MinLessThanMax') == -1) ? "Min should be less than Max" : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('MinLessThanMax')].Name())
                    );
                    return;
                }

            }
            else {
                data.ShouldShowMessageMin(true);
                data.ValidationMessageMin(
                    //"Non numeric values are not allowed"
                    ((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('NoNumericValues') == -1) ? "Non numeric values are not allowed" : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('NoNumericValues')].Name())
                    );
                return;
            }
            data.ShouldShowMessageMin(false);
            data.ValidationMessageMin("");
        }

    function onBlurEvent(data) {
        var level = data.Level();
        if ($.isNumeric(data.Max())) {
            if (Number(data.Min()) >= Number(data.Max())) {
                data.ShouldShowMessage(true);
                data.ValidationMessage(
                    //"Max should be more than Min"
                    ((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('MaxGreaterThanMin') == -1) ? "Max should be more than Min" : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('MaxGreaterThanMin')].Name())
                );
            }
            else {
                data.ShouldShowMessage(false);
                data.ValidationMessage(null);
                if (AtViewModel.SelectedSurveyComponentIdTh() === -999) {
                    $.each(AtViewModel.OverallThresholdValuesList(), function (index, value) {
                        if (value.Level() == (level + 1)) {
                            var splitstr = (data.Max().toString().indexOf('.') > 0) ? data.Max().toString().split('.') : data.Max();
                            var count = 0;
                            if (Array.isArray(splitstr) && splitstr.length > 1)
                                count = splitstr[1].length;
                            else
                                count = 1;

                            var num = Math.pow(10, -count);
                            if (isNaN(num)) num = 0;
                            value.Min(parseFloat(parseFloat(data.Max()) + parseFloat(num)).toFixed(count));
                          //  value.Min(parseFloat(parseFloat(data.Max()) + 0.01).toFixed(2));
                        }
                    });
                }
                else {
                    $.each(AtViewModel.QualThresholdValuesList(), function (index, value) {
                        if (value.Level() == (level + 1)) {
                            var splitstr = (data.Max().toString().indexOf('.') > 0) ? data.Max().toString().split('.') : data.Max();
                            var count = 0;
                            if (Array.isArray(splitstr) && splitstr.length > 1)
                                count = splitstr[1].length;
                            else
                                count = 1;

                            var num = Math.pow(10, -count);
                            if (isNaN(num)) num = 0;
                            value.Min(parseFloat(parseFloat(data.Max()) + parseFloat(num)).toFixed(count));
                            //value.Min(parseFloat(parseFloat(data.Max()) + 0.01).toFixed(2));
                        }
                    });
                }
            }
        }
        else {
            data.ShouldShowMessage(true);
            data.ValidationMessage(
                //"Non numeric values are not allowed"
                ((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('NoNumericValues') == -1) ? "Non numeric values are not allowed" : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('NoNumericValues')].Name())
            );
        }
    }

        function OverallTabClick(data, event) {
            try {
                //$('#QualitativeTabDivTh').show();
                $('#RfTabTh').hide();
                $('#FilterAreaAccordion').hide();
                $("#saveEditButtons").hide();
                $('#overalldiv').hide();
                GetOverallThresholdData();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: OverallTabClick() method in AMLThresholds.js';
                logger.logMessage(msg);
            }
        }

        function copyToAll(data, event) {
            try {
                //$('#CopyToAllPopup').modal('show');
                app.showMessage('Are you sure you want to Copy Thrsholds to all Levels, It will clear all previously saved values?', 'Apply Changes', ['Confirm', 'Cancel'], false, { primaryButtonClass: "mr-2 btn-curved fa fa-check btn btn-success autofocus", secondaryButtonClass: "mr-2 btn-curved fa fa-times btn btn-default", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-edit text-default' })
                    .then(function (option) {
                        if (option === 'Confirm') {
                            console.log(AtViewModel.ClickedRiskAreaType());
                            AtViewModel.copyToAllFlag(1);
                            if (AtViewModel.ClickedRiskAreaType() === 'QLDR' || AtViewModel.ClickedRiskAreaType() === 'CDR' || (AtViewModel.ClickedRiskAreaType() == 'QTDR' && AtViewModel.ClickedRAType() == 'A')) {
                                // CALL THE QUALITTATIVE SAVE WITH FLAG = 1
                                SaveQualitativeThresholdValues();

                            }
                            else {
                                SaveThresholdBtnClick();
                                // CALL THE QUANTITATIVE SAVE WITH FLAG = 0
                            }

                            //(data, event);
                            //alert('Hello Message');
                            //OrgLevelChangeClick();
                            //we will use the save function with an additional flag
                        }
                    });
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: copyToAll() method in AMLThresholds.js';
                logger.logMessage(msg);
            }
        }

        function GetOverallThresholdData() {
            try {
                $.ajax({
                    url: "/api/Visualization/GetOverallThresholdData",
                    data: {
                        "TableId": 0, "AssessmentType": AtViewModel.AssessmentType(), "TableType": "B", "SurveyCategoryId": AtViewModel.SelectedSurveyComponentIdTh(), "ScenarioId": AtViewModel.SelectedScenarioId()
                    },
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetOverallThresholdData() method in AMLThresholds.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult == 0 || jsonResult == null) {
                        $('#overalldiv').show();
                        $("#saveEditButtons").show();
                        $('#NoDataErrorOverallThresholds').show();
                    }
                    else {
                        $('#NoDataErrorOverallThresholds').hide();
                        $("#error").hide();
                        $('#FilterAreaAccordion').hide();
                        $('#overalldiv').show();
                        $("#saveEditButtons").show();
                        var MappedQualThresholdValue = $.map(jsonResult, function (result) {
                            return new QualThresholdValueModel(result);
                        });
                        $('#tblThreshold tbody tr').remove();
                        AtViewModel.OverallThresholdValuesList(MappedQualThresholdValue);

                        var MappedThresholdValueDup = $.map(jsonResult, function (result) {
                            return new QualThresholdValueModel(result);
                        });
                        AtViewModel.OverallThresholdValuesListDup(MappedThresholdValueDup);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetOverallThresholdData() method in AMLThresholds.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage(((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name()), "Error in Edit Operation", [((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name())], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == ((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name()))
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetOverallThresholdData() method in AMLThresholds.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail  in GetOverallThresholdData() method in AMLThresholds.js';
                    logger.logMessage(msg);
                }
            }
        }


    function QualThresholdValueModel(item) {
        try {

            var self = this;
            self.Uid = ko.observable(item.Uid);
            self.FinalRiskId = ko.observable(item.FinalRiskId);
            self.Min = ko.observable(item.Min);
            self.Max = ko.observable(item.Max);
            self.ValidationMessage = ko.observable(null);
            self.ShouldShowMessage = ko.observable(false);
            self.ValidationMessageMin = ko.observable(null);
            self.ShouldShowMessageMin = ko.observable(false);
            self.onBlur = function (data) {
                onBlurEvent(data);
            };
            self.Description = ko.observable($('<div/>').html(item.Description).text());
            //self.CSS = ko.observable($('<div/>').html(item.CSS).text());
            self.CSS = ko.observable(item.Css);
            self.Level = ko.observable(item.Level);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: QualThresholdValueModel() method in AMLThreshold.js';
            logger.logMessage(msg);
        }
    }

        //-----------------------------------------------------------Qualitative Thresholds ends here-----------------------------------------------------------------------

        //-------------------------------------------------------------Model Definition Starts Here-----------------------------------------------------------------------
        function RiskAreaModel(item) {
            try {
                var self = this;
                self.RiskAreaName = ko.observable($('<div/>').html(item.RiskAreaName).text());
                self.RiskAreaId = ko.observable(item.RiskAreaId);
                self.RiskAreaType = ko.observable($('<div/>').html(item.RiskAreaType).text());
                self.RiskAreaNotes = ko.observable($('<div/>').html(item.RiskAreaNotes).text());
                self.IsQualitative = ko.observable(item.IsQualitative);
                self.TargetRow = ko.observable();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: RiskAreaModel() method in VisualAnalyticsThresholds.js';
                logger.logMessage(msg);
            }
        };

        function RiskFactorModel(item) {
            try {
                var self = this;
                self.RiskFactorName = ko.observable($('<div/>').html(item.RiskFactorName).text());
                self.RiskFactorId = ko.observable(item.RiskFactorId);
                self.RiskAreaId = ko.observable(item.RiskAreaId);
                self.RiskAreaName = ko.observable($('<div/>').html(item.RiskAreaName).text());
                self.TargetRow = ko.observable();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: RiskFactorModel() method in VisualAnalyticsThresholds.js';
                logger.logMessage(msg);
            }
        };

        function ThresholdValueModel(item) {
            try {
                var self = this;
                self.IrlId = ko.observable(item.IrlId);
                self.IrlName = ko.observable(item.IrlName);
                var MappedChild = $.map(item.Child, function (result) {
                    return new ThresholdChildModel(result);
                });
                self.ChildList = ko.observableArray(MappedChild);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ThresholdValueModel() method in VisualAnalyticsThresholds.js';
                logger.logMessage(msg);
            }
        }

        function ThresholdChildModel(item) {
            try {
                var self = this;
                self.RiskLevelId = ko.observable(item.RiskLevelId);
                self.RiskLevelName = ko.observable(item.RiskLevelName);
                self.RiskLevelCss = ko.observable(item.RiskLevelCss);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ThresholdChildModel() method in VisualAnalyticsThresholds.js';
                logger.logMessage(msg);
            }
        }

        function SurveyCategoryModel(item) {
            try {
                var self = this;
                self.SurveyCategoryId = ko.observable(item.SurveyCategoryId);
                self.SurveyCategoryName = ko.observable(item.SurveyCategoryName);
                self.SurveyCategoryShortName = ko.observable(item.SurveyCategoryShortName);
                self.SurveyType = ko.observable(item.SurveyType);
                self.Applicability = ko.observable(item.Applicability);
                self.SurveyGroupId = ko.observable(item.SurveyGroupId);
                self.SurveyGroupFullName = ko.observable(item.SurveyGroupFullName);
                self.SurveyGroupShortName = ko.observable(item.SurveyGroupShortName);
                self.IsEditable = ko.observable(item.IsEditable);
                self.AssessmentTypeId = ko.observable(item.AssessmentTypeId);
                self.AssessmentTypeName = ko.observable(item.AssessmentTypeName);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SurveyCategoryModel() method in AMLThresholds.js';
                logger.logMessage(msg);
            }
        }

        //-------------------------------------------------------------Model Definition Ends Here-----------------------------------------------------------------------
    });
